import { render, staticRenderFns } from "./main.vue?vue&type=template&id=70035d0c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70035d0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70035d0c')) {
      api.createRecord('70035d0c', component.options)
    } else {
      api.reload('70035d0c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=70035d0c&scoped=true", function () {
      api.rerender('70035d0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabTool/main.vue"
export default component.exports